import type { LiveAdminService, NormalizeAdminServiceFromApiParams } from '../types';
import normalizeAdminServiceBillingFromApi from './normalizeAdminServiceBillingFromApi';

const normalizeAdminServiceFromApi = ({
    dto,
}: NormalizeAdminServiceFromApiParams): LiveAdminService => ({
    id: dto.id,
    schemaVersion: dto.schemaVersion,
    revision: dto.revision,
    name: dto.name,
    description: dto.description,
    iconName: dto.iconName,
    availability: dto.availability,
    organizationCount: dto.organizationCount,
    billing: normalizeAdminServiceBillingFromApi({ billing: dto.billing }),
    playbookIds: [...dto.playbookIds],
    createdBy: {
        uid: dto.createdBy.uid,
        email: dto.createdBy.email,
        displayName: dto.createdBy.displayName,
        photoURL: dto.createdBy.photoURL,
    },
    updatedBy: {
        uid: dto.updatedBy.uid,
        email: dto.updatedBy.email,
        displayName: dto.updatedBy.displayName,
        photoURL: dto.updatedBy.photoURL,
    },
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
});

export default normalizeAdminServiceFromApi;
